import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import {MatIcon} from "@angular/material/icon";

import {GuruEntity} from "../../../../model/guru-entity";
import {ConfigurationSection, UserStateService} from "../../../../services/user-state.service";
import {ModelService} from "../../../../services/model-service";
import {SelectionUtils} from "../../../selection-utils";
import {ReactiveFormsModule} from "@angular/forms";

@Component({
    selector: 'app-sa-res-accessories',
    imports: [
    MatIcon,
    ReactiveFormsModule
],
    templateUrl: './sa-res-accessories.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './sa-res-accessories.component.css'
})
export class SaResAccessoriesComponent implements OnChanges {
  private readonly modelService = inject(ModelService);
  private readonly userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  emergencyHeaterSelection!: GuruEntity;
  wallPlateSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.ACCESSORIES;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.emergencyHeaterSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USElecHtKw');
    this.wallPlateSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USWallPlate');
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    entity.Value = newValue;
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
